import { Segment } from 'fitify-ui-onboarding/src/components/Paywall/Segment/Segment'
import { SegmentCard } from 'fitify-ui-onboarding/src/components/Paywall/Segment/Segment.Styled'
import { useTranslation } from 'next-i18next/pages'
import { useMemo } from 'react'
import { styled, useTheme } from 'styled-components'

import { useMediaLogosVariant } from 'hooks/useMediaLogosVariant'
import { getImageProps } from 'utils/images'

const StyledImagesWrapper = styled(SegmentCard)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 0.75rem;

  img {
    max-width: 100%;
    height: auto;
  }
`

export const FeaturedIn = () => {
  const { t } = useTranslation()
  const { isDarkTheme } = useTheme()
  const mediaLogosVariant = useMediaLogosVariant()

  const imageProps = useMemo(() => {
    switch (mediaLogosVariant) {
      case 'cz':
        return getImageProps(
          'shared',
          'subscription',
          isDarkTheme ? 'featuredInCzWhite' : 'featuredInCzDark'
        )
      default:
        return getImageProps(
          'shared',
          'subscription',
          isDarkTheme ? 'featuredInWhite' : 'featuredInDark'
        )
    }
  }, [isDarkTheme, mediaLogosVariant])

  return (
    <Segment title={t('paywall_as_featured_in')}>
      <StyledImagesWrapper>
        <img alt="Featured in logos" {...imageProps} />
      </StyledImagesWrapper>
    </Segment>
  )
}
